/*
 * Marketplace specific configuration.
 *
 * Every filter needs to have following keys:
 * - id:     Unique id of the filter.
 * - label:  The default label of the filter.
 * - type:   String that represents one of the existing filter components:
 *           BookingDateRangeFilter, KeywordFilter, PriceFilter,
 *           SelectSingleFilter, SelectMultipleFilter.
 * - group:  Is this 'primary' or 'secondary' filter?
 *           Primary filters are visible on desktop layout by default.
 *           Secondary filters are behind "More filters" button.
 *           Read more from src/containers/SearchPage/README.md
 * - queryParamNames: Describes parameters to be used with queries
 *                    (e.g. 'price' or 'pub_amenities'). Most of these are
 *                    the same between webapp URLs and API query params.
 *                    You can't change 'dates', 'price', or 'keywords'
 *                    since those filters are fixed to a specific attribute.
 * - config: Extra configuration that the filter component needs.
 *
 * Note 1: Labels could be tied to translation file
 *         by importing FormattedMessage:
 *         <FormattedMessage id="some.translation.key.here" />
 *
 * Note 2: If you need to add new custom filter components,
 *         you need to take those into use in:
 *         src/containers/SearchPage/FilterComponent.js
 *
 * Note 3: If you just want to create more enum filters
 *         (i.e. SelectSingleFilter, SelectMultipleFilter),
 *         you can just add more configurations with those filter types
 *         and tie them with correct extended data key
 *         (i.e. pub_<key> or meta_<key>).
 */
export const userTypes = [{ label: 'Doctor', key: 'doctor' }, { label: 'Patient', key: 'patient' }];
export const specialisedOptions = [
  { label: 'General', key: 'general', value: 'general', disabled: false },
  { label: 'Dental', key: 'dental', value: 'dental', disabled: false },
  { label: 'Emergency', key: 'emergency', value: 'emergency', disabled: false },
  { label: 'Neurology', key: 'neurology', value: 'neurology' },
  { label: 'Cardiology', key: 'cardiology', value: 'cardiology' },
  { label: 'Internal Medicine', key: 'internal_medicine', value: 'internal_medicine' },
  { label: 'Onkology', key: 'onkology', value: 'onkology' },
  { label: 'Orthopedics', key: 'orthopedics', value: 'orthopedics' },
  { label: 'Surgery', key: 'surgery', value: 'surgery' },
  { label: 'Dermatology', key: 'dermatology', value: 'dermatology' },
  { label: 'Eye Health', key: 'eye_health', value: 'eye_health' },
  { label: 'Other', key: 'other', value: 'other' },
];
export const services = [
  { label: 'Home Visits', key: 'home_visits', value: 'home_visits' },
  { label: 'Video Calls', key: 'video_calls', value: 'video_calls' },
  { label: 'Appointments on site', key: 'appointments_on_site', value: 'appointments_on_site' },
];
export const species = [
  { label: 'Dog and Cat', key: 'dog_&_cat', value: 'dog_&_cat' },
  { label: 'Rodents', key: 'rodents', value: 'rodents' },
  { label: 'Exotics and Birds', key: 'exotics_&_birds', value: 'exotics_&_birds' },
  { label: 'Large Animals', key: 'large_animals', value: 'large_animals' },
];

export const organizations = [
  { label: 'Clinic', key: 'clinic', value: 'clinic' },
  { label: 'Joint Practice', key: 'joint_practice', value: 'joint_practice' },
  { label: 'Single practice', key: 'single_practice', value: 'single_practice' },
  { label: 'Mobile doctor', key: 'mobile_doctor', value: 'mobile_doctor' },
];

export const countries = [
  { label: 'Afghanistan', key: 'AF' },
  { label: 'land Islands', key: 'AX' },
  { label: 'Albania', key: 'AL' },
  { label: 'Algeria', key: 'DZ' },
  { label: 'American Samoa', key: 'AS' },
  { label: 'AndorrA', key: 'AD' },
  { label: 'Angola', key: 'AO' },
  { label: 'Anguilla', key: 'AI' },
  { label: 'Antarctica', key: 'AQ' },
  { label: 'Antigua and Barbuda', key: 'AG' },
  { label: 'Argentina', key: 'AR' },
  { label: 'Armenia', key: 'AM' },
  { label: 'Aruba', key: 'AW' },
  { label: 'Australia', key: 'AU' },
  { label: 'Austria', key: 'AT' },
  { label: 'Azerbaijan', key: 'AZ' },
  { label: 'Bahamas', key: 'BS' },
  { label: 'Bahrain', key: 'BH' },
  { label: 'Bangladesh', key: 'BD' },
  { label: 'Barbados', key: 'BB' },
  { label: 'Belarus', key: 'BY' },
  { label: 'Belgium', key: 'BE' },
  { label: 'Belize', key: 'BZ' },
  { label: 'Benin', key: 'BJ' },
  { label: 'Bermuda', key: 'BM' },
  { label: 'Bhutan', key: 'BT' },
  { label: 'Bolivia', key: 'BO' },
  { label: 'Bosnia and Herzegovina', key: 'BA' },
  { label: 'Botswana', key: 'BW' },
  { label: 'Bouvet Island', key: 'BV' },
  { label: 'Brazil', key: 'BR' },
  { label: 'British Indian Ocean Territory', key: 'IO' },
  { label: 'Brunei Darussalam', key: 'BN' },
  { label: 'Bulgaria', key: 'BG' },
  { label: 'Burkina Faso', key: 'BF' },
  { label: 'Burundi', key: 'BI' },
  { label: 'Cambodia', key: 'KH' },
  { label: 'Cameroon', key: 'CM' },
  { label: 'Canada', key: 'CA' },
  { label: 'Cape Verde', key: 'CV' },
  { label: 'Cayman Islands', key: 'KY' },
  { label: 'Central African Republic', key: 'CF' },
  { label: 'Chad', key: 'TD' },
  { label: 'Chile', key: 'CL' },
  { label: 'China', key: 'CN' },
  { label: 'Christmas Island', key: 'CX' },
  { label: 'Cocos (Keeling) Islands', key: 'CC' },
  { label: 'Colombia', key: 'CO' },
  { label: 'Comoros', key: 'KM' },
  { label: 'Congo', key: 'CG' },
  { label: 'Congo, The Democratic Republic of the', key: 'CD' },
  { label: 'Cook Islands', key: 'CK' },
  { label: 'Costa Rica', key: 'CR' },
  { label: 'Cote DIvoire', key: 'CI' },
  { label: 'Croatia', key: 'HR' },
  { label: 'Cuba', key: 'CU' },
  { label: 'Cyprus', key: 'CY' },
  { label: 'Czech Republic', key: 'CZ' },
  { label: 'Denmark', key: 'DK' },
  { label: 'Djibouti', key: 'DJ' },
  { label: 'Dominica', key: 'DM' },
  { label: 'Dominican Republic', key: 'DO' },
  { label: 'Ecuador', key: 'EC' },
  { label: 'Egypt', key: 'EG' },
  { label: 'El Salvador', key: 'SV' },
  { label: 'Equatorial Guinea', key: 'GQ' },
  { label: 'Eritrea', key: 'ER' },
  { label: 'Estonia', key: 'EE' },
  { label: 'Ethiopia', key: 'ET' },
  { label: 'Falkland Islands (Malvinas)', key: 'FK' },
  { label: 'Faroe Islands', key: 'FO' },
  { label: 'Fiji', key: 'FJ' },
  { label: 'Finland', key: 'FI' },
  { label: 'France', key: 'FR' },
  { label: 'French Guiana', key: 'GF' },
  { label: 'French Polynesia', key: 'PF' },
  { label: 'French Southern Territories', key: 'TF' },
  { label: 'Gabon', key: 'GA' },
  { label: 'Gambia', key: 'GM' },
  { label: 'Georgia', key: 'GE' },
  { label: 'Germany', key: 'DE' },
  { label: 'Ghana', key: 'GH' },
  { label: 'Gibraltar', key: 'GI' },
  { label: 'Greece', key: 'GR' },
  { label: 'Greenland', key: 'GL' },
  { label: 'Grenada', key: 'GD' },
  { label: 'Guadeloupe', key: 'GP' },
  { label: 'Guam', key: 'GU' },
  { label: 'Guatemala', key: 'GT' },
  { label: 'Guernsey', key: 'GG' },
  { label: 'Guinea', key: 'GN' },
  { label: 'Guinea-Bissau', key: 'GW' },
  { label: 'Guyana', key: 'GY' },
  { label: 'Haiti', key: 'HT' },
  { label: 'Heard Island and Mcdonald Islands', key: 'HM' },
  { label: 'Holy See (Vatican City State)', key: 'VA' },
  { label: 'Honduras', key: 'HN' },
  { label: 'Hong Kong', key: 'HK' },
  { label: 'Hungary', key: 'HU' },
  { label: 'Iceland', key: 'IS' },
  { label: 'India', key: 'IN' },
  { label: 'Indonesia', key: 'ID' },
  { label: 'Iran, Islamic Republic Of', key: 'IR' },
  { label: 'Iraq', key: 'IQ' },
  { label: 'Ireland', key: 'IE' },
  { label: 'Isle of Man', key: 'IM' },
  { label: 'Israel', key: 'IL' },
  { label: 'Italy', key: 'IT' },
  { label: 'Jamaica', key: 'JM' },
  { label: 'Japan', key: 'JP' },
  { label: 'Jersey', key: 'JE' },
  { label: 'Jordan', key: 'JO' },
  { label: 'Kazakhstan', key: 'KZ' },
  { label: 'Kenya', key: 'KE' },
  { label: 'Kiribati', key: 'KI' },
  { label: "Korea, Democratic People's Republic of", key: 'KP' },
  { label: 'Korea, Republic of', key: 'KR' },
  { label: 'Kuwait', key: 'KW' },
  { label: 'Kyrgyzstan', key: 'KG' },
  { label: 'Lao PeopleS Democratic Republic', key: 'LA' },
  { label: 'Latvia', key: 'LV' },
  { label: 'Lebanon', key: 'LB' },
  { label: 'Lesotho', key: 'LS' },
  { label: 'Liberia', key: 'LR' },
  { label: 'Libyan Arab Jamahiriya', key: 'LY' },
  { label: 'Liechtenstein', key: 'LI' },
  { label: 'Lithuania', key: 'LT' },
  { label: 'Luxembourg', key: 'LU' },
  { label: 'Macao', key: 'MO' },
  { label: 'Macedonia, The Former Yugoslav Republic of', key: 'MK' },
  { label: 'Madagascar', key: 'MG' },
  { label: 'Malawi', key: 'MW' },
  { label: 'Malaysia', key: 'MY' },
  { label: 'Maldives', key: 'MV' },
  { label: 'Mali', key: 'ML' },
  { label: 'Malta', key: 'MT' },
  { label: 'Marshall Islands', key: 'MH' },
  { label: 'Martinique', key: 'MQ' },
  { label: 'Mauritania', key: 'MR' },
  { label: 'Mauritius', key: 'MU' },
  { label: 'Mayotte', key: 'YT' },
  { label: 'Mexico', key: 'MX' },
  { label: 'Micronesia, Federated States of', key: 'FM' },
  { label: 'Moldova, Republic of', key: 'MD' },
  { label: 'Monaco', key: 'MC' },
  { label: 'Mongolia', key: 'MN' },
  { label: 'Montenegro', key: 'ME' },
  { label: 'Montserrat', key: 'MS' },
  { label: 'Morocco', key: 'MA' },
  { label: 'Mozambique', key: 'MZ' },
  { label: 'Myanmar', key: 'MM' },
  { label: 'Namibia', key: 'NA' },
  { label: 'Nauru', key: 'NR' },
  { label: 'Nepal', key: 'NP' },
  { label: 'Netherlands', key: 'NL' },
  { label: 'Netherlands Antilles', key: 'AN' },
  { label: 'New Caledonia', key: 'NC' },
  { label: 'New Zealand', key: 'NZ' },
  { label: 'Nicaragua', key: 'NI' },
  { label: 'Niger', key: 'NE' },
  { label: 'Nigeria', key: 'NG' },
  { label: 'Niue', key: 'NU' },
  { label: 'Norfolk Island', key: 'NF' },
  { label: 'Northern Mariana Islands', key: 'MP' },
  { label: 'Norway', key: 'NO' },
  { label: 'Oman', key: 'OM' },
  { label: 'Pakistan', key: 'PK' },
  { label: 'Palau', key: 'PW' },
  { label: 'Palestinian Territory, Occupied', key: 'PS' },
  { label: 'Panama', key: 'PA' },
  { label: 'Papua New Guinea', key: 'PG' },
  { label: 'Paraguay', key: 'PY' },
  { label: 'Peru', key: 'PE' },
  { label: 'Philippines', key: 'PH' },
  { label: 'Pitcairn', key: 'PN' },
  { label: 'Poland', key: 'PL' },
  { label: 'Portugal', key: 'PT' },
  { label: 'Puerto Rico', key: 'PR' },
  { label: 'Qatar', key: 'QA' },
  { label: 'Reunion', key: 'RE' },
  { label: 'Romania', key: 'RO' },
  { label: 'Russian Federation', key: 'RU' },
  { label: 'RWANDA', key: 'RW' },
  { label: 'Saint Helena', key: 'SH' },
  { label: 'Saint Kitts and Nevis', key: 'KN' },
  { label: 'Saint Lucia', key: 'LC' },
  { label: 'Saint Pierre and Miquelon', key: 'PM' },
  { label: 'Saint Vincent and the Grenadines', key: 'VC' },
  { label: 'Samoa', key: 'WS' },
  { label: 'San Marino', key: 'SM' },
  { label: 'Sao Tome and Principe', key: 'ST' },
  { label: 'Saudi Arabia', key: 'SA' },
  { label: 'Senegal', key: 'SN' },
  { label: 'Serbia', key: 'RS' },
  { label: 'Seychelles', key: 'SC' },
  { label: 'Sierra Leone', key: 'SL' },
  { label: 'Singapore', key: 'SG' },
  { label: 'Slovakia', key: 'SK' },
  { label: 'Slovenia', key: 'SI' },
  { label: 'Solomon Islands', key: 'SB' },
  { label: 'Somalia', key: 'SO' },
  { label: 'South Africa', key: 'ZA' },
  { label: 'South Georgia and the South Sandwich Islands', key: 'GS' },
  { label: 'Spain', key: 'ES' },
  { label: 'Sri Lanka', key: 'LK' },
  { label: 'Sudan', key: 'SD' },
  { label: 'Suriname', key: 'SR' },
  { label: 'Svalbard and Jan Mayen', key: 'SJ' },
  { label: 'Swaziland', key: 'SZ' },
  { label: 'Sweden', key: 'SE' },
  { label: 'Switzerland', key: 'CH' },
  { label: 'Syrian Arab Republic', key: 'SY' },
  { label: 'Taiwan, Province of China', key: 'TW' },
  { label: 'Tajikistan', key: 'TJ' },
  { label: 'Tanzania, United Republic of', key: 'TZ' },
  { label: 'Thailand', key: 'TH' },
  { label: 'Timor-Leste', key: 'TL' },
  { label: 'Togo', key: 'TG' },
  { label: 'Tokelau', key: 'TK' },
  { label: 'Tonga', key: 'TO' },
  { label: 'Trinidad and Tobago', key: 'TT' },
  { label: 'Tunisia', key: 'TN' },
  { label: 'Turkey', key: 'TR' },
  { label: 'Turkmenistan', key: 'TM' },
  { label: 'Turks and Caicos Islands', key: 'TC' },
  { label: 'Tuvalu', key: 'TV' },
  { label: 'Uganda', key: 'UG' },
  { label: 'Ukraine', key: 'UA' },
  { label: 'United Arab Emirates', key: 'AE' },
  { label: 'United Kingdom', key: 'GB' },
  { label: 'United States', key: 'US' },
  { label: 'United States Minor Outlying Islands', key: 'UM' },
  { label: 'Uruguay', key: 'UY' },
  { label: 'Uzbekistan', key: 'UZ' },
  { label: 'Vanuatu', key: 'VU' },
  { label: 'Venezuela', key: 'VE' },
  { label: 'Viet Nam', key: 'VN' },
  { label: 'Virgin Islands, British', key: 'VG' },
  { label: 'Virgin Islands, U.S.', key: 'VI' },
  { label: 'Wallis and Futuna', key: 'WF' },
  { label: 'Western Sahara', key: 'EH' },
  { label: 'Yemen', key: 'YE' },
  { label: 'Zambia', key: 'ZM' },
  { label: 'Zimbabwe', key: 'ZW' },
];

export const DOCTOR_INBOX_TABS = [
  'video_calls',
  'appointments',
  'home_visits',
  'messages',
  'clients',
  'analytics',
];
export const PATIENT_INBOX_TABS = [
  'video_calls',
  'appointments',
  'home_visits',
  'messages',
  'documents',
  'animals',
];

export const SHARE_ATTACHMENT_TYPES = [
  { key: 'report', label: 'Report' },
  { key: 'prescription', label: 'Prescription' },
  // { key: 'invoice', label: 'Invoice' },
];

export const filters = [
  {
    id: 'dates-length',
    label: 'Dates',
    type: 'BookingDateRangeLengthFilter',
    group: 'primary',
    // Note: BookingDateRangeFilter is fixed filter,
    // you can't change "queryParamNames: ['dates'],"
    queryParamNames: ['dates', 'minDuration'],
    config: {
      // A global time zone to use in availability searches. As listings
      // can be in various time zones, we must decide what time zone we
      // use in search when looking for available listings within a
      // certain time interval.
      //
      // If you have all/most listings in a certain time zone, change this
      // config value to that.
      //
      // See: https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
      searchTimeZone: 'Etc/UTC',

      // Options for the minimum duration of the booking
      options: [
        { key: '0', label: 'Any length' },
        { key: '60', label: '1 hour', shortLabel: '1h' },
        { key: '120', label: '2 hours', shortLabel: '2h' },
      ],
    },
  },
  // {
  //   id: 'price',
  //   label: 'Price',
  //   type: 'PriceFilter',
  //   group: 'primary',
  //   // Note: PriceFilter is fixed filter,
  //   // you can't change "queryParamNames: ['price'],"
  //   queryParamNames: ['price'],
  //   // Price filter configuration
  //   // Note: unlike most prices this is not handled in subunits
  //   config: {
  //     min: 0,
  //     max: 1000,
  //     step: 5,
  //   },
  // },
  {
    id: 'keyword',
    label: 'Keyword',
    type: 'KeywordFilter',
    group: 'primary',
    // Note: KeywordFilter is fixed filter,
    // you can't change "queryParamNames: ['keywords'],"
    queryParamNames: ['keywords'],
    // NOTE: If you are ordering search results by distance
    // the keyword search can't be used at the same time.
    // You can turn on/off ordering by distance from config.js file.
    config: {},
  },
  {
    id: 'organization',
    label: 'Organization',
    type: 'SelectSingleFilter',
    group: 'primary',
    queryParamNames: ['pub_organization'],
    config: {
      // Optional modes: 'has_all', 'has_any'
      // https://www.sharetribe.com/api-reference/marketplace.html#extended-data-filtering
      searchMode: 'has_all',

      // "key" is the option you see in Flex Console.
      // "label" is set here for this web app's UI only.
      // Note: label is not added through the translation files
      // to make filter customizations a bit easier.
      options: [...organizations],
    },
  },
  {
    id: 'specialisedOptions',
    label: 'Specialised',
    type: 'SelectMultipleFilter',
    group: 'secondary',
    queryParamNames: ['pub_specialisedOption'],
    config: {
      // Optional modes: 'has_all', 'has_any'
      // https://www.sharetribe.com/api-reference/marketplace.html#extended-data-filtering
      searchMode: 'has_all',

      // "key" is the option you see in Flex Console.
      // "label" is set here for this web app's UI only.
      // Note: label is not added through the translation files
      // to make filter customizations a bit easier.
      options: [...specialisedOptions],
    },
  },
  {
    id: 'services',
    label: 'Services',
    type: 'SelectMultipleFilter',
    group: 'secondary',
    queryParamNames: ['pub_services'],
    config: {
      // Optional modes: 'has_all', 'has_any'
      // https://www.sharetribe.com/api-reference/marketplace.html#extended-data-filtering
      searchMode: 'has_all',

      // "key" is the option you see in Flex Console.
      // "label" is set here for this web app's UI only.
      // Note: label is not added through the translation files
      // to make filter customizations a bit easier.
      options: [...services],
    },
  },
  {
    id: 'species',
    label: 'Species',
    type: 'SelectMultipleFilter',
    group: 'secondary',
    queryParamNames: ['pub_species'],
    config: {
      // Optional modes: 'has_all', 'has_any'
      // https://www.sharetribe.com/api-reference/marketplace.html#extended-data-filtering
      searchMode: 'has_all',

      // "key" is the option you see in Flex Console.
      // "label" is set here for this web app's UI only.
      // Note: label is not added through the translation files
      // to make filter customizations a bit easier.
      options: [...species],
    },
  },
];

export const sortConfig = {
  // Enable/disable the sorting control in the SearchPage
  active: true,

  // Note: queryParamName 'sort' is fixed,
  // you can't change it since Flex API expects it to be named as 'sort'
  queryParamName: 'sort',

  // Internal key for the relevance option, see notes below.
  relevanceKey: 'relevance',

  // Keyword filter is sorting the results already by relevance.
  // If keyword filter is active, we need to disable sorting.
  conflictingFilters: ['keyword'],

  options: [
    { key: 'createdAt', label: 'Newest' },
    { key: '-createdAt', label: 'Oldest' },
    { key: '-price', label: 'Lowest price' },
    { key: 'price', label: 'Highest price' },

    // The relevance is only used for keyword search, but the
    // parameter isn't sent to the Marketplace API. The key is purely
    // for handling the internal state of the sorting dropdown.
    { key: 'relevance', label: 'Relevance', longLabel: 'Relevance (Keyword search)' },
  ],
};
